import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo } from 'react';
import { useAccountDataQuery } from 'queries/account';
export const AntdRlUISwitcherContext = /*#__PURE__*/ createContext({
    isEnabled: false
});
export const AntdRlUISwitcherProvider = ({ children, forceOff, forceEnable: _forceEnable })=>{
    var _ref;
    var _accountData_accountMeta_features, _accountData_accountMeta;
    const { data: accountData } = useAccountDataQuery();
    const _isEnabled = (_ref = accountData === null || accountData === void 0 ? void 0 : (_accountData_accountMeta = accountData.accountMeta) === null || _accountData_accountMeta === void 0 ? void 0 : (_accountData_accountMeta_features = _accountData_accountMeta.features) === null || _accountData_accountMeta_features === void 0 ? void 0 : _accountData_accountMeta_features.newUI) !== null && _ref !== void 0 ? _ref : false;
    const isTesting = process.env.PLAYWRIGHT_TESTS;
    const forceEnable = isTesting ? true : _forceEnable;
    const isEnabled = (forceEnable !== null && forceEnable !== void 0 ? forceEnable : _isEnabled) && !forceOff;
    const value = useMemo(()=>({
            isEnabled
        }), [
        isEnabled
    ]);
    useEffect(()=>{
        if (isEnabled) {
            document.documentElement.setAttribute('data-new-theme-enabled', 'true');
        } else {
            document.documentElement.removeAttribute('data-new-theme-enabled');
        }
    }, [
        isEnabled
    ]);
    return /*#__PURE__*/ _jsx(AntdRlUISwitcherContext.Provider, {
        value: value,
        children: children
    });
};
export const useAntdRlUISwitcher = ()=>{
    const context = useContext(AntdRlUISwitcherContext);
    if (!context) {
        return false;
    }
    return context.isEnabled;
};
